import moment from "moment-timezone";

async function renderPickupDate(order, timezone) {
  if (!order) return;
  if (!order.selectedDate?.iso && !order.chosen_date) return;

  const date = order.selectedDate?.iso
    ? order.selectedDate.iso
    : order.chosen_date;
  const time = order.selectedTime ? order.selectedTime : order.chosen_time;

  moment.tz.setDefault(timezone);

  const mom = moment();
  const today = moment(mom.format("YYYY-MM-DD")).isSame(date);
  const tomorrow = moment(mom.add(1, "day").format("YYYY-MM-DD")).isSame(date);

  const localDate =
    today || tomorrow
      ? today
        ? "Today"
        : "Tomorrow"
      : moment(date).format("ddd, MMMM D");

  await this.$store.dispatch("orderStatus/setLocalOrderDateTime", {
    localDate,
    time,
  });
}

export { renderPickupDate };
